module.exports = __webpack_public_path__ + "img/sticker-flower.cefa3cf1.png";